import React from 'react';
import { observer } from 'mobx-react';
import Button from 'react-bootstrap/esm/Button';

import { CentreModal } from 'src/components/Modals';
import { useProfileWidgetStore } from './StoreProvider';

import 'src/components/Modals/modals.style.css';
import { LoaderButton } from '../../../../../libs/ui-kit/buttons/LoaderButton';

export const UnblockingModal = observer(() => {
  const store = useProfileWidgetStore();

  return (
    <CentreModal isShow={store.unblockingModal.isVisible} title="Разблокировать" onHide={store.unblockingModal.hide}>
      <div className="text-muted">Пользователь</div>
      <div className="mb-7">{store.profile?.fullName}</div>
      <div className="d-flex">
        <div className="mr-1 d-flex" style={{ width: '136px' }}>
          <LoaderButton variant="success" onClick={store.onSubmitUnblock} isLoading={store.unblockProfileInProgress}>
            Разблокировать
          </LoaderButton>
        </div>
        <Button
          disabled={store.unblockProfileInProgress}
          variant="light"
          className="mx-1"
          onClick={store.unblockingModal.hide}>
          Отменить
        </Button>
      </div>
    </CentreModal>
  );
});
